module.exports = __webpack_public_path__ + "img/company15.0ce9eed9.png";